import type { SceneContent } from '../../../presentation/types';

/** Source: docs/product-content/MINT-TRAVEL.md (positioning only; no feature claims). */
export const mintTravel: SceneContent = {
  id: 'mint-travel',
  shortLabel: 'TRAVEL',
  title: 'MINT Travel & Events',
  seconds: 30,
  brand: 'mint-travel',
  bridgeIn: 'Back to the MINT core, and another branch.',
  atmosphere: (step) => ({ pattern: step >= 1 ? 'inward' : 'drift', density: 0.2, opacity: 0.06, cameraZ: 14.2 }),
  script: {
    title: 'MINT Travel & Events',
    onScreen: ['PEOPLE · PLACES · EVENTS · TIME · CONTEXT · INFORMATION', 'A DIFFERENT DOMAIN.', 'THE SAME FOUNDATION.', 'MINT TRAVEL & EVENTS', 'Specialised intelligence for travel and event contexts.', 'CONTEXT CHANGES.', 'THE INTELLIGENCE FOUNDATION REMAINS.'],
    visual: 'The MINT core in the centre. Domain concepts (people, places, events, time, context, information) drift separately on the left, then connect into MINT. A new branch activates to the right and MINT Travel & Events is named. The diagram dims behind the closing pair.',
    narration: [
      'Travel and events are a very different domain: people, places, events, time, and the context around all of them.',
      'The foundation does not change. MINT connects that domain context the same way it connects any other.',
      'That specialisation is MINT Travel & Events: MINT intelligence specialised for travel and event contexts.',
      'The context changes. The intelligence foundation remains.',
    ],
    presenterNotes: [
      'Domain concepts appear separately. "A different domain."',
      'They connect into MINT. "The same foundation."',
      'The branch activates. Name MINT Travel & Events. Keep it at the domain level; do not describe features.',
      '"Context changes. The intelligence foundation remains."',
    ],
  },
};
